import { render } from "./json-builder-preview.vue?vue&type=template&id=d3aebed2&scoped=true"
import script from "./json-builder-preview.vue?vue&type=script&lang=js"
export * from "./json-builder-preview.vue?vue&type=script&lang=js"

import "./json-builder-preview.vue?vue&type=style&index=0&id=d3aebed2&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3aebed2"]])

export default __exports__